export default {
      id: "icon-web-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-web",
      toString: function () {
        return this.url;
      }
    }